import {
    UPDATE_USER,
} from '../../actionTypes';

const INITIAL_STATE = {
    id: '',
    name: '',
    isAdmin: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_USER:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                isAdmin: action.payload.isAdmin
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/services/user/reducer.js